export const PALETTE = {
  reloadActive: 0x78dfff,
  reloadInactive: 0x285474,
  reloadIcon: 0xd9f7ff,
  reviveGreen: 0x7dff9a,
  gold: 0xf5c542,
  nightSky: 0x0b1020,
  aimGuide: 0xe8f0ff,
} as const;
